<template>
  <div class="car-booking" data-js="workshop--confirm">
    <div class="car-content-introduction car-reduced-width">
      <span class="car-headline">
        {{$t('workshopRating.confirmed')}}
      </span>
      <p>
        {{$t('workshopRating.confirmedDescription')}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkshopRatingSucess'
};
</script>
